import React, { useState } from 'react';
import './buttonsRedesSign.scss';
import { withRouter } from 'react-router-dom';
import { LAWYERS_CONTACTED } from '../../routes';


import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { signUpFacebookCreator } from '../../store/actions/UserAction';


const BtnFB = (props) => {
    const { img, text, color, border, role } = props

    const [ errorMessageFB, setErrorMessageFB ] = useState(false)

    const signUpFacebook = () => {
        
        if (
            props.role &&
            (props.role === 'lawFirm' ||
            props.role === 'lawyer')
        ) {
            setErrorMessageFB(true)
        } else {
            props.signUpFacebookCreator()
                .then(res => {
    
                    props.history.push(LAWYERS_CONTACTED);
                })
                .catch(err => {})
        }
    }

    return (
        <>
            <div
                onClick={signUpFacebook}
                className={
                    errorMessageFB ?
                    'ButtonsRedesSignF fbColorsError' :
                    'ButtonsRedesSignF fbColors'
                }
            >
                <div className='center-container'>
                    <div className='img-container'>
                        <img src="/img/btns/facebook.svg" />
                    </div>
                    <div className='text-container'>
                        <p className='text-btn'>
                            Continuar con Facebook
                        </p>
                    </div>
                </div>
            </div>
            {errorMessageFB ?
                <p className='ButtonsRedesSignF_errorText'>
                    Ya te encuentras autenticado como {props.role === 'lawyer' ? 'abogado' : 'despacho'}.
                </p> : null
            }
        </>
    );
}

const mapStateToProps = state => ({
    role: state.authClient.role,
})

const mapDispatchToProps = dispatch => ({
    signUpFacebookCreator: () => dispatch(signUpFacebookCreator())
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BtnFB));